import { template as template_15f89076479a44a393282fc123d79b92 } from "@ember/template-compiler";
import { withDefault } from '@eflexsystems/ember-composable-helpers';
import MultipieceIcon from 'eflex/components/multipiece-icon';
import BsTooltip from 'eflex/components/bs-tooltip';
import { t } from 'ember-intl';
export default template_15f89076479a44a393282fc123d79b92(`
<div class="col-auto">
  <label class="form-label">
    {{t "quantity"}}
  </label>
  <div
    class="
      jem-multipiece-standalone-quantity
      form-control
      form-control-lg
      border-0
      d-flex
      align-items-center
      fw-semibold
      px-3
      bg-gray-800
    "
  >
    <span class="d-flex align-items-center test-is-multipiece-icon">
      <MultipieceIcon @iconColorClass="bg-white" />
      <BsTooltip @placement='right' @triggerEvents="hover">
        {{t "multipiece"}}
      </BsTooltip>
      &nbsp;
    </span>
    {{withDefault @buildStatus.multipieceQuantities '-'}}
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
